import React from 'react';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import '@/api/axiosClient';
import App from '@/App.jsx';
import { ErrorBoundary } from '@/components/shared/ErrorBoundary';
import { AuthProvider } from '@/contexts/AuthProvider';
import { HealthProvider } from '@/hooks/useHealth';
import { ToastProvider } from '@/hooks/useToast';
import { GlobalLoadingProvider } from '@/providers/GlobalLoadingProvider';
import { AppVersionProvider } from '@/providers/AppVersionProvider';
import { ModalStackProvider } from '@/contexts/ModalStackContext';

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <ErrorBoundary>
      <HealthProvider>
        <ToastProvider>
          <GlobalLoadingProvider>
            <ModalStackProvider>
              <BrowserRouter basename="/">
                <AppVersionProvider>
                  <AuthProvider>
                    <App />
                  </AuthProvider>
                </AppVersionProvider>
              </BrowserRouter>
            </ModalStackProvider>
          </GlobalLoadingProvider>
        </ToastProvider>
      </HealthProvider>
    </ErrorBoundary>
  </StrictMode>
);
